import {
  validateHyattExperienceIsEligible,
  ValidateListingsResponse,
} from 'api/hyatt';
import useSWR from 'swr';

const useValidateHyattEligibility = (
  brandId: string,
  isHyattLMSEnabled: boolean,
  exchangeIds?: string[] | null,
) => {
  const swr = useSWR(
    exchangeIds && exchangeIds.length > 0 && brandId && isHyattLMSEnabled
      ? [exchangeIds, brandId]
      : null,
    async ([ids, brand]) => {
      const response: ValidateListingsResponse =
        await validateHyattExperienceIsEligible(ids, brand);
      return response;
    },
  );

  if (swr.error) {
    console.error('Error validating Hyatt experience:', swr.error);
    return { isEligible: false, isLoading: false };
  }

  return {
    isEligible: swr.data ? isAllListingsValid(swr.data) : false,
    areAnyEligible: swr.data ? areAnyListingsValid(swr.data) : false,
    isLoading: !swr.data,
  };
};

const isAllListingsValid = (response: ValidateListingsResponse): boolean => {
  return (
    Array.isArray(response.data.invalidListingIds) &&
    response.data.invalidListingIds.length === 0
  );
};

const areAnyListingsValid = (response: ValidateListingsResponse): boolean => {
  return (
    Array.isArray(response.data.validListingIds) &&
    response.data.validListingIds.length > 0
  );
};
export default useValidateHyattEligibility;
